import { useEffect, useRef, useState } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";
import { toast } from "sonner";

const FORMATS = [Html5QrcodeSupportedFormats.CODE_128, Html5QrcodeSupportedFormats.CODE_39, Html5QrcodeSupportedFormats.QR_CODE, Html5QrcodeSupportedFormats.EAN_13];

export const useScanner = (onCode, continuous = false) => {
  const ref = useRef(null);
  const cb = useRef(onCode);
  const last = useRef({ code: "", t: 0 });
  const handled = useRef(false);
  const [on, setOn] = useState(false);
  cb.current = onCode;

  const stop = async () => {
    if (ref.current?.isScanning) await ref.current.stop().catch(() => {});
    setOn(false);
  };
  const start = async () => {
    try {
      ref.current = ref.current || new Html5Qrcode("qr-reader", { formatsToSupport: FORMATS, verbose: false, experimentalFeatures: { useBarCodeDetectorIfSupported: true } });
      handled.current = false;
      const qrbox = (w, h) => {
        const s = Math.max(150, Math.floor(Math.min(w, h) * 0.85));
        return { width: s, height: s };
      };
      const config = { fps: 15, qrbox, videoConstraints: { facingMode: "environment", width: { ideal: 1280 }, height: { ideal: 720 }, advanced: [{ focusMode: "continuous" }] } };
      const onRead = (raw) => {
        const first = String(raw).split(/\r?\n/)[0].trim();
        const m = first.match(/\/[bq]\/([^/?#\s]+)/i);
        const text = m ? decodeURIComponent(m[1]) : first;
        if (continuous) {
          const t = Date.now();
          if (text === last.current.code && t - last.current.t < 2500) return;
          last.current = { code: text, t };
        } else {
          if (handled.current) return;
          handled.current = true;
          stop();
        }
        cb.current(text);
      };
      try {
        await ref.current.start({ facingMode: "environment" }, config, onRead);
      } catch {
        await ref.current.start({ facingMode: "environment" }, { fps: 15, qrbox }, onRead);
      }
      setOn(true);
    } catch (e) {
      toast.error("Camera unavailable. Allow camera access or type the code.");
    }
  };
  useEffect(() => () => {
    if (ref.current?.isScanning) ref.current.stop().catch(() => {});
  }, []);
  return { on, start, stop };
};
